import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'

import RepSelectContainer from './component'

import * as PropertyActions from 'app/modules/user/properties/actions'
import * as PropertySelectors from 'app/modules/user/properties/selectors'

const usersWithExtension = PropertySelectors.makeUsersWithProperty('extensionInstalled')

const mapStateToProps = state => ({
  options: usersWithExtension(state).toJS(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchUsersByPropertyName: PropertyActions.fetchUsersByPropertyName,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchUsersByPropertyName(['extensionInvited', 'extensionInstalled'])
    },
  }),
)(RepSelectContainer)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingDisplay/RepSelectContainer/index.js